import clsx from 'clsx'
import { ReactNode } from 'react'
// import { CountryService } from '../service/CountryService';
// import './FormDemo.css';

const AuthLayout = ({
  children,
  showLogo,
}: {
  children?: ReactNode
  showLogo?: boolean
}) => {
  return (
    <div className="auth-layout flex w-full h-screen overflow-x-hidden">
      <div
        className="auth-layout-inner flex flex-column md:flex-row m-auto w-full h-full align-items-center justify-content-center"
        style={{ maxWidth: 1440, maxHeight: 800 }}
      >
        <div className="auth-layout-logo w-full md:w-auto flex align-items-center justify-content-center">
          <img
            src="/images/logo-text.svg"
            alt=""
            className={clsx(
              'object-cover w-12rem md:w-full max-w-full',
              showLogo ? 'opacity-100' : 'opacity-0'
            )}
          />
        </div>

        <div className="auth-layout-content flex flex-column justify-content-center gap-4 md:gap-6">
          {children}
        </div>
      </div>
    </div>
  )
}
export default AuthLayout
